import { render, staticRenderFns } from "./RestoreView.vue?vue&type=template&id=6e20acd4&scoped=true&"
import script from "./RestoreView.vue?vue&type=script&lang=js&"
export * from "./RestoreView.vue?vue&type=script&lang=js&"
import style0 from "./RestoreView.vue?vue&type=style&index=0&id=6e20acd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e20acd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
